import { render, staticRenderFns } from "./copyTemplateForm.vue?vue&type=template&id=54a58b20&scoped=true&"
import script from "./copyTemplateForm.vue?vue&type=script&lang=js&"
export * from "./copyTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a58b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a58b20')) {
      api.createRecord('54a58b20', component.options)
    } else {
      api.reload('54a58b20', component.options)
    }
    module.hot.accept("./copyTemplateForm.vue?vue&type=template&id=54a58b20&scoped=true&", function () {
      api.rerender('54a58b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/incomingInspectionMgr/nskTemplateMgr/components/copyTemplateForm.vue"
export default component.exports